var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Tabs, TabList, TabPanels, TabPanel, Tab as ReachTab, } from '@reach/tabs';
import styled, { css, } from 'styled-components';
import { margin } from 'styled-system';
import { Accordion, AccordionItem } from '../Accordion';
import { filterProps, get, useMediaSize } from '../tools/utils';
var lastStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-right: 1px solid ", ";\n"], ["\n  border-right: 1px solid ", ";\n"])), get.colors('slate-3'));
var FilteredTab = filterProps(ReachTab, ['patina', 'last', 'color']);
var StyledTab = styled(FilteredTab)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: auto;\n  height: 45px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  padding: 0px ", ";\n  position: relative;\n  top: 1px;\n  border-right: none;\n  font-size: ", ";\n  color: ", ";\n  font-family: ", ";\n\n  &[data-selected] {\n    background-color: ", ";\n    border-bottom: none;\n    z-index: 1;\n    color: ", ";\n\n    ::after {\n      content: '';\n      border-bottom: 1px solid ", ";\n      position: relative;\n      display: block;\n      padding: inherit;\n    }\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  width: auto;\n  height: 45px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  padding: 0px ", ";\n  position: relative;\n  top: 1px;\n  border-right: none;\n  font-size: ", ";\n  color: ", ";\n  font-family: ", ";\n\n  &[data-selected] {\n    background-color: ", ";\n    border-bottom: none;\n    z-index: 1;\n    color: ", ";\n\n    ::after {\n      content: '';\n      border-bottom: 1px solid ", ";\n      position: relative;\n      display: block;\n      padding: inherit;\n    }\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), get.colors('light-gray'), get.colors('slate-3'), get.space('lg'), get.fontSizes('md'), get.colors('slate-5'), get.fonts('regular'), get.colors('white'), get.colors('slate-5'), get.colors('white'), function (_a) {
    var patina = _a.patina, colors = _a.theme.colors;
    return patina
        ? "background-color: ".concat(colors['patina-2'], ";")
        : "color: ".concat(colors.bluesuedeshoes, ";");
}, function (_a) {
    var last = _a.last;
    return last ? lastStyles : css(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
}, function (_a) {
    var color = _a.color;
    return color
        ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          border-top: 4px solid ", ";\n        "], ["\n          border-top: 4px solid ", ";\n        "])), get.colors(color)) : css(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
});
var StyledTabPanel = styled(TabPanel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  box-shadow: 0 ", " 0 0 rgba(0, 0, 0, 0.15);\n  background-color: ", ";\n  padding: ", ";\n"], ["\n  border: 1px solid ", ";\n  box-shadow: 0 ", " 0 0 rgba(0, 0, 0, 0.15);\n  background-color: ", ";\n  padding: ", ";\n"])), get.colors('slate-3'), get.space('xxs'), get.colors('white'), get.space('lg'));
export var List = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(TabList, __assign({}, rest), React.Children.map(children, function (child, index) {
        var length = React.Children.count(children);
        return React.cloneElement(child, __assign({ last: length - 1 === index }, rest));
    })));
};
export var Panels = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return React.createElement(TabPanels, __assign({}, rest), children);
};
export var Panel = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(StyledTabPanel, __assign({ tabIndex: -1 }, rest), children));
};
export var Tab = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.patina, patina = _c === void 0 ? false : _c, _d = _a.last, last = _d === void 0 ? false : _d, color = _a.color, allytmln = _a.allytmln, isSelected = _a.isSelected, _userInteractedRef = _a._userInteractedRef, _onSelect = _a._onSelect, _id = _a._id;
    return (React.createElement(StyledTab, { patina: patina, last: last, color: color, isSelected: isSelected, _userInteractedRef: _userInteractedRef, _onSelect: _onSelect, _id: _id, className: className, allytmln: allytmln }, children));
};
var StyledTabs = styled(Tabs)(margin);
var Wrapper = function (_a) {
    var children = _a.children, className = _a.className, patina = _a.patina, onChange = _a.onChange, suppressMdDownLayout = _a.suppressMdDownLayout, rest = __rest(_a, ["children", "className", "patina", "onChange", "suppressMdDownLayout"]);
    var isLgUp = useMediaSize('LgUp');
    if (!suppressMdDownLayout && !isLgUp) {
        return (React.createElement(Accordion, { variant: "CONTAINER" }, React.Children.map(children, function (child) {
            return React.cloneElement(child, { patina: patina, onChange: onChange });
        })));
    }
    return (React.createElement(StyledTabs, __assign({ className: className, onChange: onChange }, rest),
        React.createElement(List, __assign({}, rest), React.Children.map(children, function (child) {
            return React.cloneElement(child, __assign({ patina: patina, isTab: true, suppressMdDownLayout: suppressMdDownLayout }, rest));
        })),
        React.createElement(Panels, __assign({}, rest), React.Children.map(children, function (child) {
            return React.cloneElement(child, __assign({ suppressMdDownLayout: suppressMdDownLayout }, rest));
        }))));
};
var TabWithPanel = function (_a) {
    var tab = _a.tab, panel = _a.panel, color = _a.color, _b = _a.patina, patina = _b === void 0 ? false : _b, isTab = _a.isTab, suppressMdDownLayout = _a.suppressMdDownLayout, allytmln = _a.allytmln, rest = __rest(_a, ["tab", "panel", "color", "patina", "isTab", "suppressMdDownLayout", "allytmln"]);
    var isLgUp = useMediaSize('LgUp');
    if (!suppressMdDownLayout && !isLgUp) {
        var content = {
            variant: 'CONTAINER',
            payload: React.createElement(React.Fragment, null, panel),
        };
        return React.createElement(AccordionItem, { title: tab, content: content });
    }
    if (isTab) {
        return (React.createElement(Tab, __assign({ color: color, patina: patina, allytmln: allytmln }, rest), tab));
    }
    return React.createElement(Panel, __assign({}, rest), panel);
};
export default { Wrapper: Wrapper, TabWithPanel: TabWithPanel };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Tabs.js.map